import { Preferences } from "@capacitor/preferences";
import { isNativeApp } from "./platform";

// The apps sign in with a bearer token instead of the website's cookie, since
// their pages load from a different origin than the API. It lives in the app's
// private storage, and in memory for each request. The website never has one.
const KEY = "gridaction.session";
let token: string | null = null;

/** Call once before the first request. */
export async function loadSessionToken(): Promise<void> {
  if (!isNativeApp) return;
  token = (await Preferences.get({ key: KEY })).value;
}

export function sessionToken(): string | null {
  return token;
}

export async function saveSessionToken(value: string | null): Promise<void> {
  if (!isNativeApp) return;
  token = value;
  if (value) await Preferences.set({ key: KEY, value });
  else await Preferences.remove({ key: KEY });
}
